import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { FormWeb } from 'app/shared/model/form.model';
import { AppUtilService } from 'app/shared/service/app-util.service';
import { ToastrService } from 'app/shared/service/toastr.service';

@Component({
  selector: 'cc-form-modal-tool-bar',
  templateUrl: 'form-modal-tool-bar.html',
  styleUrls: ['../../styles/components/modal-tool-bar.scss'],
})
export class FormModalToolBarComponent {
  @Input() canDelete: boolean;
  @Input() canToggleActivity: boolean;
  @Input() canSave: boolean;
  @Input() activitiesState: boolean;
  @Input() isWorking: boolean;
  @Input() form: FormWeb;
  @Input() isPreview: boolean;
  @Input() isCloning: boolean;
  @Input() showActions: boolean;
  @Input() formName: string;
  @Input() navigateOnSignUpToFormModal: boolean;

  @Output() remove = new EventEmitter();
  @Output() download = new EventEmitter();
  @Output() clone = new EventEmitter();
  @Output() close = new EventEmitter();
  @Output() save = new EventEmitter();
  @Output() send = new EventEmitter();
  @Output() customise = new EventEmitter();
  @Output() useThisTemplate = new EventEmitter<void>();
  @Output() toggleActivities = new EventEmitter<boolean>();

  constructor(
    public readonly appUtilService: AppUtilService,
    public readonly activeModal: NgbActiveModal,
    private readonly toastr: ToastrService,
  ) {}

  onRemove() {
    if (this.canDelete) {
      this.remove.emit();
    } else {
      this.toastr.errorByKey('noPermissionDelete');
    }
  }

  onToggleActivity() {
    this.toggleActivities.emit();
  }
}
